// Negative delays reproduce the same staggered timing as the mobile WAIT_BEFORE = [0, 100, 200, 300, 400] ms
const DELAY_CLASSES = [
	"[animation-delay:0s]",
	"[animation-delay:-0.8s]",
	"[animation-delay:-0.7s]",
	"[animation-delay:-0.6s]",
	"[animation-delay:-0.5s]",
];

type LoaderProps = {
	className?: string;
};

export const Loader = ({ className }: LoaderProps) => {
	const classes = [
		"mx-auto",
		"flex",
		"flex-row",
		"justify-center",
		"items-center",
		"gap-1.5",
		"w-25",
		"h-25",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div className={classes}>
			{DELAY_CLASSES.map((delayClass, index) => (
				<span
					key={index}
					className={`w-1 h-12.5 bg-[#008EB9] rounded-xs animate-scale flex justify-center items-center ${delayClass}`}
				/>
			))}
		</div>
	);
};

export default Loader;

